import * as vp from 'vopay';
import { Button } from 'UI';
import { FunctionComponent, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from '../AccountingSystemOpen.module.scss';
import { Payment } from '../types';
import { useTranslation } from 'react-i18next';

type AccountingSystemScheduleDialogueProps = {
  isVisible: boolean;
  payments: Payment[];
  close: () => void;
};
type FC = FunctionComponent<AccountingSystemScheduleDialogueProps>;

const PartiallyPaidDialogue: FC = ({ close, isVisible, payments }: AccountingSystemScheduleDialogueProps) => {
  const { Modal, Box, Table } = vp;
  const [isExpanded, setIsExpanded] = useState<(boolean | undefined)[]>([]);
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.OpenTab.Dialogs.PartiallyPaid' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  useEffect(() => {
    setIsExpanded([]);
  }, [isVisible]);
  const tableProps: vp.TableProps = {
    name: 'partially-paid-table',
    variant: 'railz',
    columns: {
      id: {
        header: t('id'),
        align: 'center',
      },
      date: {
        header: t('date'),
        align: 'center',
      },
      transactionId: {
        header: t('transactionId'),
        align: 'center',
      },
      amount: {
        header: t('amount'),
        align: 'center',
      },
      dropdown: {
        header: '',
        align: 'center',
      },
    },
    expandedRows: payments.map((payment, index) =>
      isExpanded[index] ? (
        <div className={styles.partiallyPaidExpandedContainer}>
          <Box base="8" gapSize="12px" width="100%" flx="col">
            {payment.details.map((detail) => (
              <Box flx="row" jc="sb">
                <div className={styles.partiallyPaidExpandedLabel}>{detail.label}</div>
                <div className={styles.partiallyPaidExpandedAmount}>{detail.amount}</div>
              </Box>
            ))}
          </Box>
        </div>
      ) : undefined,
    ),
    rows: payments.map((payment, index) => ({
      id: String(index + 1),
      date: payment.date,
      class: isExpanded[index] ? 'partiallyPaidExpanded' : '',
      transactionId: payment.transactionId ? (
        <Link to={`/transactions-history/details/Transaction/${payment.transactionId || ''}/${payment.currency}`}>
          <div className={styles.partiallyPaidLink}>{payment.transactionId}</div>
        </Link>
      ) : (
        ''
      ),
      amount: <Box jc="center">{payment.amount} </Box>,
      dropdown: (
        <vp.Button
          id="partially-paid-table-expand"
          label=""
          color="none"
          width="auto"
          onClick={() => {
            setIsExpanded((prev) => {
              const newExpanded = [...prev];
              newExpanded[index] = !newExpanded[index];
              return newExpanded;
            });
          }}
          icon={isExpanded[index] ? 'angleTop' : 'angleDown'}
          noPadding
          noShadow
          background="transparent"
          iconLocation="center"
          iconHeight="14px"
          iconWidth="14px"
          iconColor="primary-dark"
        />
      ),
    })),
  };
  return (
    <Modal isVisible={isVisible} enableBgClick={false}>
      <div className={styles.dialoguePartiallyPaid}>
        <Box flx="col" base="8" gap="lg">
          <Table {...tableProps} />
          <Box gap="sm" flx="row" jc="center">
            <Button id="confirmationDialogue-close" colorScheme="primary" style={{ width: '100%' }} onClick={close}>
              {tGlobal('Buttons.close')}
            </Button>
          </Box>
        </Box>
      </div>
    </Modal>
  );
};

export default PartiallyPaidDialogue;
